<page-header [section]="'service-logs'">
  <page-title>User Reports</page-title>
  <page-blurb>Active User Reports.</page-blurb>
</page-header>
